"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _I4CBIWTXcjs = require('./I4CBIWTX.cjs');

// src/utils/platform.ts
function isTouchDevice() {
  return _I4CBIWTXcjs.canUseDOM && !!navigator.maxTouchPoints;
}
function isApple() {
  if (!_I4CBIWTXcjs.canUseDOM) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari() {
  return _I4CBIWTXcjs.canUseDOM && isApple() && /apple/i.test(navigator.vendor);
}
function isFirefox() {
  return _I4CBIWTXcjs.canUseDOM && /firefox\//i.test(navigator.userAgent);
}
function isMac() {
  return _I4CBIWTXcjs.canUseDOM && navigator.platform.startsWith("Mac") && !isTouchDevice();
}







exports.isTouchDevice = isTouchDevice; exports.isApple = isApple; exports.isSafari = isSafari; exports.isFirefox = isFirefox; exports.isMac = isMac;
